export default __webpack_public_path__ + "static/media/03_gallery_NN-CS89LB_QPQ_Water-tank-nz.cee0c4b9.jpg";